<!-- Company page tabs (sit at the bottom of the banner card). Grouped pages
     open from a ▾ dropdown: the tab label navigates, the ▾ only opens it. -->
<nav class="gs-biz-tabs" aria-label="Company page sections">

  <button type="button" id="business_menu_home" class="gs-biz-tab"
    [class.active]="isPathActive('/business/post')" (click)="menuclick('post')">Home</button>

  <button type="button" id="business_menu_about" class="gs-biz-tab"
    [class.active]="isPathActive('/business/about')" (click)="menuclick('about')">About</button>

  <!-- Employees (▾ Manage Employees for admins) -->
  <!-- Count = pending join requests (handled on Manage Employees). Shown on the
       tab while the dropdown is closed, on Manage Employees while it's open. -->
  <div class="gs-biz-tab-group" dropdown #empDd="bs-dropdown"
    [class.active]="isPathActive('/business/employee') || isPathActive('/business/employee-requests')">
    <button type="button" id="business_menu_employees" class="gs-biz-tab" (click)="menuclick('employee')">
      Employees
      <span class="gs-biz-tab-badge" *ngIf="isAdminView && reqPendinCnt > 0 && !empDd.isOpen">{{reqPendinCnt}}</span>
    </button>
    <!-- Only the ▾ is admin-gated. The menu must stay outside any *ngIf:
         ngx-bootstrap binds the first *dropdownMenu it sees and never
         re-binds, so a re-created menu (isAdminView off→on) never shows. -->
    <button *ngIf="isAdminView" type="button" class="gs-biz-tab-caret" dropdownToggle aria-label="More employee pages">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
    <ul *dropdownMenu class="dropdown-menu gs-biz-tab-menu" role="menu">
      <li role="menuitem">
        <a [class.active]="isPathActive('/business/employee-requests')" (click)="menuclick('employee-requests')">
          Manage Employees
          <span class="gs-biz-tab-badge" *ngIf="reqPendinCnt > 0">{{reqPendinCnt}}</span>
        </a>
      </li>
    </ul>
  </div>

  <!-- Followers (▾ Invites Sent for admins) -->
  <!-- Count = follower invites sent; same tab ↔ dropdown hand-off as Employees. -->
  <div class="gs-biz-tab-group" dropdown #folDd="bs-dropdown"
    [class.active]="isPathActive('/business/follower') || isPathActive('/business/followerRequest-sent')">
    <button type="button" class="gs-biz-tab" (click)="menuclick('follower')">
      Followers
      <span class="gs-biz-tab-badge" *ngIf="isAdminView && visitorsCnt > 0 && !folDd.isOpen">{{visitorsCnt}}</span>
    </button>
    <!-- Same as Employees: only the ▾ is admin-gated, the menu stays put. -->
    <button *ngIf="isAdminView" type="button" class="gs-biz-tab-caret" dropdownToggle aria-label="More follower pages">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
    <ul *dropdownMenu class="dropdown-menu gs-biz-tab-menu" role="menu">
      <li role="menuitem">
        <a [class.active]="isPathActive('/business/followerRequest-sent')" (click)="menuclick('followerRequest-sent')">
          Invites Sent
          <span class="gs-biz-tab-badge" *ngIf="visitorsCnt > 0">{{visitorsCnt}}</span>
        </a>
      </li>
    </ul>
  </div>

  <button type="button" class="gs-biz-tab"
    [class.active]="isPathActive('/business/community')" (click)="menuclick('community')">Communities</button>

  <button type="button" class="gs-biz-tab"
    [class.active]="isPathActive('/business/jobs')" (click)="menuclick('jobs')">Jobs</button>

  <button type="button" class="gs-biz-tab" *ngIf="isAdminView"
    [class.active]="isPathActive('/business/analytics')" (click)="menuclick('analytics')">Analytics</button>

  <!-- Manage Page: the whole tab opens the dropdown (it has no page of its own) -->
  <div class="gs-biz-tab-group" dropdown *ngIf="isAdminView"
    [class.active]="isPathActive('/business/admin') || isPathActive('/business/business-settings') || isPathActive('/business/deactivate')">
    <button type="button" class="gs-biz-tab gs-biz-tab--menu" dropdownToggle>
      Manage Page
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
    <ul *dropdownMenu class="dropdown-menu gs-biz-tab-menu gs-biz-tab-menu--right" role="menu">
      <li role="menuitem">
        <a [class.active]="isPathActive('/business/admin')" (click)="menuclick('admin')">Page Admin</a>
      </li>
      <li role="menuitem" *ngIf="isSuperAdminView">
        <a [class.active]="isPathActive('/business/business-settings')" (click)="menuclick('business-settings')">Security Settings</a>
      </li>
      <li role="menuitem" *ngIf="isSuperAdminView">
        <a [class.active]="isPathActive('/business/deactivate')" (click)="menuclick('deactivate')">Deactivate Page</a>
      </li>
    </ul>
  </div>

</nav>
